/**
 * 常量
 */

/**
 * 邦邦豆交易类型常量
 */
export const BEAN_TRADE_TYPE_LIST = {
  '1': '推荐人推荐获得',
  '2': '订单购买获得',
  '3': '订单支付支出',
  '4': '续费购买获得',
  '5': '续费支付支出',
  '6': '退款',
  '7': '续费未通过退还'
}

/**
 * 工作台组件图标集合
 */
export const MODULE_UNIT_IMGS = [
  {
    name: '饼图',
    value: 'pie-chart',
    path: './static/img/moduleUnit/pie-chart.png'
  },
  {
    name: '环形图',
    value: 'circular-graph',
    path: './static/img/moduleUnit/circular-graph.png'
  },
  {
    name: '柱状图',
    value: 'bar-chart',
    path: './static/img/moduleUnit/bar-chart.png'
  },
  {
    name: '折线图',
    value: 'line-chart',
    path: './static/img/moduleUnit/line-chart.png'
  },
  {
    name: '表格',
    value: 'table',
    path: './static/img/moduleUnit/table.png'
  },
  {
    name: '订单列表',
    value: 'order-list',
    path: './static/img/moduleUnit/order-list.png'
  },
  {
    name: '企业服务列表',
    value: 'enterprise-service-list',
    path: './static/img/moduleUnit/enterprise-service-list.png'
  },
  {
    name: '团队业绩',
    value: 'team-achievement',
    path: './static/img/moduleUnit/team-achievement.png'
  },
  {
    name: '账号管理',
    value: 'account-manage',
    path: './static/img/moduleUnit/account-manage.png'
  },
  {
    name: '按时完成量',
    value: 'aswc-count',
    path: './static/img/moduleUnit/aswc-count.png'
  },
  {
    name: '按时完成率',
    value: 'aswc-ratio',
    path: './static/img/moduleUnit/aswc-ratio.png'
  },
  {
    name: '本月成单',
    value: 'bycd',
    path: './static/img/moduleUnit/bycd.png'
  },
  {
    name: '本月回执',
    value: 'byhz',
    path: './static/img/moduleUnit/byhz.png'
  },
  {
    name: '本月利润',
    value: 'by-profit',
    path: './static/img/moduleUnit/by-profit.png'
  },
  {
    name: '部门业绩',
    value: 'dept-achievement',
    path: './static/img/moduleUnit/dept-achievement.png'
  },
  {
    name: '待完成量',
    value: 'dwcl',
    path: './static/img/moduleUnit/dwcl.png'
  },
  {
    name: '单位家数',
    value: 'dwjs',
    path: './static/img/moduleUnit/dwjs.png'
  },
  {
    name: '当月完成单量',
    value: 'dywcdl',
    path: './static/img/moduleUnit/dywcdl.png'
  },
  {
    name: '地址支出',
    value: 'address-pay',
    path: './static/img/moduleUnit/address-pay.png'
  },
  {
    name: '订单',
    value: 'order',
    path: './static/img/moduleUnit/order.png'
  },
  {
    name: '累计客户流失',
    value: 'ljkhls',
    path: './static/img/moduleUnit/ljkhls.png'
  },
  {
    name: '利润',
    value: 'profit',
    path: './static/img/moduleUnit/profit.png'
  },
  {
    name: '实习期人数',
    value: 'intern-count',
    path: './static/img/moduleUnit/intern-count.png'
  },
  {
    name: '试用期人数',
    value: 'probation-count',
    path: './static/img/moduleUnit/probation-count.png'
  },
  {
    name: '团队业绩',
    value: 'team-achievemnet2',
    path: './static/img/moduleUnit/team-achievemnet2.png'
  },
  {
    name: '完成量',
    value: 'wcl',
    path: './static/img/moduleUnit/wcl.png'
  },
  {
    name: '业绩',
    value: 'achievement',
    path: './static/img/moduleUnit/achievement.png'
  },
  {
    name: '业绩指标',
    value: 'achievement-quota',
    path: './static/img/moduleUnit/achievement-quota.png'
  },
  {
    name: '已续费',
    value: 'yxf',
    path: './static/img/moduleUnit/yxf.png'
  },
  {
    name: '在职人数',
    value: 'staff-count',
    path: './static/img/moduleUnit/staff-count.png'
  },
  {
    name: '正式员工数',
    value: 'regular-staff-count',
    path: './static/img/moduleUnit/regular-staff-count.png'
  },
  {
    name: '资历代办',
    value: 'zldb',
    path: './static/img/moduleUnit/zldb.png'
  },
  {
    name: '总单量',
    value: 'total-order',
    path: './static/img/moduleUnit/total-order.png'
  }
]

/**
 * 评分选项
 */
export const SCORE_OPTIONS = [
  { score: 3, label: '3分-不合格' },
  { score: 3.25, label: '3.25-部分有待提高' },
  { score: 3.5, label: '3.5分-基本满足预期' },
  { score: 3.75, label: '3.75分-部分超过预期' },
  { score: 4, label: '4分-卓越' }
]

/**
 * 文件图片路径
 */
export const FILE_IMAGE_PATH = {
  doc: '/static/img/images/word.png',
  docx: '/static/img/images/word.png',
  xls: '/static/img/images/excel.png',
  xlsx: '/static/img/images/excel.png',
  pdf: '/static/img/images/pdf.png',
  zip: '/static/img/images/zip.png'
}

/**
 * 文件类型
 */
export const FILE_MIME_TYPES = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  zip: 'application/zip'
}

/**
 * 绩效考核指标类型
 */
export const PERFORMANCE_QUOTAS = [
  { name: '财务维度', value: 6 },
  { name: '客户维度', value: 7 },
  { name: '内部运营与流程维度', value: 8 },
  { name: '学习和成长维度', value: 9 }
]

/**
 * 预算费用类型
 */
export const BUDGET_FEE_TYPE_LIST = [
  { label: '固定费用', value: '1' },
  { label: '浮动费用', value: '2' },
]

/**
 * 分页记录数
 */
export const PAGE_SIZES = [10, 20, 50, 100]

/**
 * 预算类型集合
 */
export const BUDGET_TYPE_LIST = [
  { name: '预算初始值', value: '1' },
  { name: '预算结余', value: '2' },
  { name: '预算追加', value: '3' },
  { name: '预算滚动', value: '4' },
  { name: '预算调整', value: '5' }
]

/**
 * 预算查询类型
 */
export const BUDGET_QUERY_TYPES = [
  { name: '对方账号', value: 'dfAccount' },
  { name: '对方户名', value: 'dfAcctName' },
  { name: '交易明细', value: 'detailed' },
  { name: '备注', value: 'remark' }
]

/**
 * 预算调整方式
 */
export const BUDGET_ADJUST_TYPES = [
  { name: '预算调入', value: '1' },
  { name: '预算调出', value: '2' }
]

/**
 * 成本类型集合
 */
export const COST_TYPE_LIST = [
  { value: '地址费', label: '地址费', disabled: false },
  { value: '刻章费', label: '刻章费', disabled: false },
  { value: '代办费', label: '代办费', disabled: false },
  { value: '注册公司', label: '注册公司', disabled: false },
  { value: '记账报税', label: '记账报税', disabled: false },
  { value: '地址变更', label: '地址变更', disabled: false }
]

// 推送方式
export const PUSH_METHOD_MAP = {
  '1': '微信',
  '2': '短信',
  '3': '邮件'
}

/**
 * 订单费用类型列表
 */
export const ORDER_COST_TYPE_LIST = [
  { value: '0', label: '地址费' },
  { value: '1', label: '刻章费' },
  { value: '2', label: '代办费' },
  { value: '3', label: '注册公司' },
  { value: '4', label: '记账报税' },
  { value: '5', label: '地址变更' },
  { value: '6', label: '其他费用' }
]

/**
 * 付款周期列表
 */
export const PAY_CYCLE_LIST = [
  { label: '月付', value: 'month' },
  { label: '季付', value: 'quarter' },
  { label: '半年付', value: 'half_year' },
  { label: '年付', value: 'year' }
]

/**
 * 记账状态集合
 */
export const BOOK_STATUS_LIST = [
  { label: '停用', value: '1' },
  { label: '续费', value: '2' },
  { label: '暂停服务', value: '3' },
  { label: '存量注销', value: '4' },
]

/**
 * 账本状态
 */
export const LEDGER_STATUS_LIST = [
  { name: '在库', value: 'in' },
  { name: '借出', value: 'lend' },
  { name: '出库', value: 'mail' },
  { name: '冻结', value: 'freeze' }
]



// WEBPACK FOOTER //
// ./src/common/constant.js